import React, { useState, useEffect } from 'react';
import { songsAPI } from '../services/api';
import styled from 'styled-components';


const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StarsContainer = styled.div`
  display: flex;
  gap: 2px;
`;

const Star = styled.button<{ filled: boolean; hover: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  color: ${props => props.filled || props.hover ? 'var(--accent-color)' : 'var(--text-muted)'};
  font-size: 16px;
  transition: all 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
`;

const AverageRating = styled.span`
  color: var(--text-muted);
  font-size: 0.9rem;
`;

interface StarRatingProps {
  songId: number;
  currentRating: number;
}

const StarRating: React.FC<StarRatingProps> = ({ songId, currentRating }) => {
  const [userRating, setUserRating] = useState<number | null>(null);
  const [hoverRating, setHoverRating] = useState<number | null>(null);

  useEffect(() => {
    const loadRating = async () => {
      try {
        const response = await songsAPI.getRating(songId);
        setUserRating(response.data.rating);
      } catch (error) {
        console.error('Erro ao carregar avaliação:', error);
      }
    };
    
    loadRating();
  }, [songId]);



  const handleRating = async (rating: number) => {
    try {
      await songsAPI.rate(songId, rating);
      setUserRating(rating);
      
      // Salvar como favorita se rating >= 4
      if (rating >= 4) {
        const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
        const songData = { id: songId, name: 'Música Favorita', average_rating: rating, file_path: '/path' };
        const newFavorites = [songData, ...favorites.filter((f: any) => f.id !== songId)].slice(0, 50);
        localStorage.setItem('favorites', JSON.stringify(newFavorites));
      }
    } catch (error: any) {
      console.error('Erro ao avaliar música:', error);
      // Se erro de autenticação, não fazer nada - deixar o usuário continuar
      if (error.response?.status === 401) {
        console.log('Erro de autenticação ao avaliar música');
      }
    }
  };

  return (
    <RatingContainer>
      <StarsContainer>
        {[1, 2, 3, 4, 5].map(star => (
          <Star
            key={star}
            filled={userRating ? star <= userRating : false}
            hover={hoverRating ? star <= hoverRating : false}
            onClick={() => handleRating(star)}
            onMouseEnter={() => setHoverRating(star)}
            onMouseLeave={() => setHoverRating(null)}
          >
            {(userRating && star <= userRating) || (hoverRating && star <= hoverRating) ? '⭐' : '☆'}
          </Star>
        ))}
      </StarsContainer>
      
      {currentRating > 0 && (
        <AverageRating>
          {currentRating.toFixed(1)} ⭐
        </AverageRating>
      )}
    </RatingContainer>
  );
};

export default StarRating;